import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getAllInstallationTasksThunk } from 'components/pages/installation/thunk/installationTaskThunk';
import { PAGINATION_DEFAULT } from 'utils/constants';
import { SCREEN_TYPE } from 'utils/enums';

const initialState: InstallTaskState = {
    screenMode: SCREEN_TYPE.list,
    selectedItem: undefined,
    formSearch: undefined,
    dataTable: [],
    paginateMetaData: PAGINATION_DEFAULT,
    sort: 'task_id:asc',
    selectedItems: [],
    isDetailLayout: false,
    isShowDeleteButton: false,
    getKeywords: [],
};

export const installTaskSlice = createSlice({
    name: 'installTask',
    initialState,
    reducers: {
        // List
        setSelectedItem: (state, action: PayloadAction<InstallationTable | undefined>) => {
            state.selectedItem = action.payload;
        },
        // Common
        setMode: (state, action: PayloadAction<SCREEN_TYPE>) => {
            state.screenMode = action.payload;
        },
        setKeywords: (state, action: PayloadAction<string[]>) => {
            state.getKeywords = action.payload;
        },
        setFormSearch: (state, action: PayloadAction<InstallationSearch | undefined>) => {
            state.formSearch = action.payload;
        },
        setDataTable: (state, action: PayloadAction<InstallationTable[]>) => {
            state.dataTable = action.payload;
        },
        setSort: (state, action: PayloadAction<string | undefined>) => {
            state.sort = action.payload;
        },
        setPaginateMetaData: (state, action: PayloadAction<Pagination>) => {
            state.paginateMetaData = action.payload;
        },
        setSelectedItems: (state, action: PayloadAction<number[]>) => {
            state.selectedItems = action.payload;
        },
        // Common
        setDetailLayout: (state, action: PayloadAction<boolean>) => {
            state.isDetailLayout = action.payload;
        },
        setShowDeleteButton: (state, action: PayloadAction<boolean>) => {
            state.isShowDeleteButton = action.payload;
        },

        handleBackInstallationTask: (state) => {
            state.isDetailLayout = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getAllInstallationTasksThunk.fulfilled, (state, action) => {
            state.dataTable = action.payload.data ?? [];
            state.paginateMetaData = action.payload.pagination || PAGINATION_DEFAULT;
        });
    },
});

export const {
    setSort,
    setDataTable,
    setPaginateMetaData,
    setMode,
    setSelectedItems,
    setDetailLayout,
    setShowDeleteButton,
    handleBackInstallationTask,
    setSelectedItem,
    setKeywords,
    setFormSearch,
} = installTaskSlice.actions;

export default installTaskSlice.reducer;
